import * as localization from '@happylife-a/localization';
// import webCore from '@happylife-a/web-core';
import * as helpers from '../../helpers';

export default function useUpdateLocaleInRouter(locale = '', initialPrefix = '') {
  return function (newLocale) {
    if (locale === newLocale) {
      return;
    }

    const { pathname = '', search: query = '', hash = '' } = window.location || {};

    const initialUrl = `${pathname}${query}${hash}`;

    const normalizedPrefix = (initialPrefix || '').replace(/^\/+|\/+$/g, '');

    // Parse the current path into segments
    let pathOnly = pathname || '';
    pathOnly = pathOnly.startsWith('/') ? pathOnly.substring(1) : pathOnly;
    const segments = pathOnly ? pathOnly.split('/') : [];

    // Determine where the locale segment should be
    const hasPrefix = normalizedPrefix && segments[0] === normalizedPrefix;
    let localeIndex = hasPrefix ? 1 : 0;

    let currentLocale =
      (segments[localeIndex] &&
        localization.locales.includes(segments[localeIndex]) &&
        segments[localeIndex]) ||
      null;

    // If locale is missing, insert it (and prefix if provided but missing)
    if (!currentLocale) {
      currentLocale = localization.getDefaultLocale();

      if (normalizedPrefix) {
        if (hasPrefix) {
          segments.splice(1, 0, currentLocale);
        } else {
          // Prepend prefix then locale
          segments.unshift(currentLocale);
          segments.unshift(normalizedPrefix);
        }
      } else {
        // No prefix case: prepend locale
        segments.unshift(currentLocale);
      }

      // Recompute locale index after insertion
      localeIndex = normalizedPrefix ? 1 : 0;
    }

    // Replace the locale segment with the new one
    if (segments[localeIndex] !== newLocale) {
      segments[localeIndex] = newLocale;
    }

    const updatedUrl = helpers.url.buildUrlFromParts([...segments, `${query}${hash}`]);

    if (initialUrl !== updatedUrl) {
      window.history.replaceState({}, '', updatedUrl);
    }
  };
}
